import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { CommitteeDto } from './dto/committee.dto';
import { CommitteeSearchDto } from './dto/committee-search.dto';

@Injectable({
  providedIn: 'root',
})
export class CommitteeService {
  constructor(private _apiService: ApiService) {}

  search(dto: CommitteeSearchDto): Promise<PagedResultGeneric<CommitteeDto>> {
    return this._apiService.postPaged('Committees/Search', dto);
  }

  get(id: number): Promise<CommitteeDto> {
    return this._apiService.get(`Committee/${id}`);
  }

  create(dto: CommitteeDto): Promise<number> {
    return this._apiService.post('Committees', dto);
  }

  update(dto: CommitteeDto): Promise<void> {
    return this._apiService.put(`Committee/${dto.CommitteeID}`, dto);
  }

  delete(id: number) {
    return this._apiService.delete(`Committee/${id}`);
  }
}
